import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-da74d798"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"background-color":"var(--cm-color-card-bg)","padding":"15px"}
}
const _hoisted_2 = {
  class: "gap-y-20",
  style: {"display":"flex","flex-direction":"column","overflow-y":"auto"}
}
const _hoisted_3 = ["title"]
const _hoisted_4 = { style: {"flex":"1"} }

import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { ref, onMounted, computed, watch, PropType } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'FileTypeItem',
  props: {
  modelValue: {
    type: Array,
    default: () => ([])
  },
  visible: {
    type: Boolean,
    default: () => false
  },
  list: {
    type: Array as PropType<{ type: number, data: any[] }[]>,
    required: true
  },
  checkAll: {
    type: Boolean,
    default: () => true
  },
  disabled: {
    type: Boolean,
    default: () => false
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const { t } = useI18n()
const fileTypeLabel = (type: number) => t('sensitiveFileScanning.fileType' + type)
const emits = __emit
const form = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  }
})
const formFile = ref({})
const data = ref([])
const fileTypeValues = ref({})
const checkAll = ref(props.checkAll)
const isIndeterminate = ref(false)
const handleCheckAll = () => {
  checkAll.value = !checkAll.value
  data.value.forEach(item => {
    item.checkAll = checkAll.value
    item.isIndeterminate = false
  })
  isIndeterminate.value = false
  fileCheckAll(checkAll.value)
  emits('update:modelValue', Object.values(formFile.value).flat(1))
}
const changeTypes = (item) => {
  item.isIndeterminate = formFile.value[item.prop]?.length && (formFile.value[item.prop]?.length < item.data?.length)
  item.checkAll = formFile.value[item.prop].length === item.data.length
  isIndeterminate.value = Object.values(formFile.value).flat(1)?.length && Object.values(formFile.value).flat(1)?.length < Object.values(fileTypeValues.value).flat(1)?.length
  checkAll.value = Object.values(formFile.value).flat(1)?.length === Object.values(fileTypeValues.value).flat(1)?.length
  emits('update:modelValue', Object.values(formFile.value).flat(1))
}
const handleCheckAllChange = (item) => {
  item.checkAll = !item.checkAll
  item.isIndeterminate = !item.checkAll && formFile.value[item.prop]?.length && (formFile.value[item.prop]?.length < item.data?.length)
  formFile.value[item.prop] = item.checkAll && item.data || []
  isIndeterminate.value = Object.values(formFile.value).flat(1).length && Object.values(formFile.value).flat(1)?.length < Object.values(fileTypeValues.value).flat(1)?.length
  checkAll.value = Object.values(formFile.value).flat(1)?.length === Object.values(fileTypeValues.value).flat(1)?.length
  emits('update:modelValue', Object.values(formFile.value).flat(1))
}
const fileCheckAll = (isCheckAll) => {
  formFile.value = props.list.reduce((p, c, i) => (p['fileType' + c.type] = isCheckAll ? c.data : [], p), {})
  props.checkAll && emits('update:modelValue', Object.values(formFile.value).flat(1))
}
watch(() => props.visible, (nv, ov) => {
    fileTypeValues.value = props.list.reduce((p, c, i) => (p['fileType' + c.type] = c.data, p), {})
    data.value = props.list.map(item => ({ label: fileTypeLabel(item.type), prop: 'fileType' + item.type, data: item.data, checkAll: props.checkAll, isIndeterminate: false }))
    formFile.value = props.list.reduce((p, c, i) => (p['fileType' + c.type] = props.checkAll ? c.data : [], p), {})
  if (nv) {
    if (!props.checkAll) {
      form.value.forEach(value => {
        for (let item in fileTypeValues.value) {
          if (fileTypeValues.value[item].includes(value)) {
            formFile.value[item].push(value)
            emits('update:modelValue', Object.values(formFile.value).flat(1))
          }
        }
      })
      checkAll.value = Object.values(formFile.value).flat(1).length === Object.values(fileTypeValues.value).flat(1).length
      isIndeterminate.value = Object.values(formFile.value).flat(1).length && Object.values(formFile.value).flat(1).length < Object.values(fileTypeValues.value).flat(1).length
      data.value.forEach(item => {
        item.checkAll = item.data.length === formFile.value[item.prop].length
        item.isIndeterminate = formFile.value[item.prop].length && (formFile.value[item.prop].length < item.data.length)
      })
    } else {
      checkAll.value = true
      data.value.forEach(item => {
        item.checkAll = checkAll.value
        item.isIndeterminate = false
      })
      isIndeterminate.value = false
      emits('update:modelValue', Object.values(fileTypeValues.value).flat(1))
    }
  }
}, {
  immediate: true,
})


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            "model-value": checkAll.value,
            disabled: __props.disabled,
            indeterminate: isIndeterminate.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (handleCheckAll()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.selectAll')), 1)
            ]),
            _: 1
          }, 8, ["model-value", "disabled", "indeterminate"]))
        : _createCommentVNode("", true),
      (data.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "gap-20",
              style: {"display":"flex"},
              key: item.type
            }, [
              _createElementVNode("div", {
                title: `${!item.checkAll ? _ctx.$t('sensitiveFileScanning.selectAll') : _ctx.$t('sensitiveFileScanning.cancelSelectAll')}${item.label}`
              }, [
                _createVNode(_component_el_checkbox, {
                  disabled: __props.disabled,
                  "model-value": item.checkAll,
                  indeterminate: item.isIndeterminate,
                  onChange: ($event: any) => (handleCheckAllChange(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "model-value", "indeterminate", "onChange"])
              ], 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: formFile.value[item.prop],
                  "onUpdate:modelValue": ($event: any) => ((formFile.value[item.prop]) = $event),
                  disabled: __props.disabled,
                  onChange: ($event: any) => (changeTypes(item))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data || [], (opt) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        style: {"width":"50px"},
                        value: opt,
                        label: opt
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(opt), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "label"]))
                    }), 256))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", { fileTypeValues: fileTypeValues.value })
  ]))
}
}

})